import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { AiOutlineControl } from "react-icons/ai";
import { IoCheckmarkCircle } from "react-icons/io5";
import { LuArrowRight } from "react-icons/lu";
import UnitsIcons from "./UnitsIcons";
import { setSidebarCollapsed } from "../store/actions/authActions";
import { CiCircleAlert } from "react-icons/ci";
import { LuPanelLeft } from "react-icons/lu";
import { IoDocumentTextOutline } from "react-icons/io5";
import { PiShieldCheck } from "react-icons/pi";
import { BsFiles } from "react-icons/bs";
import { CiServer } from "react-icons/ci";
import { GoAlert } from "react-icons/go";
import { LuWorkflow } from "react-icons/lu";
import { HiOutlineChartBar } from "react-icons/hi2";
import { CiViewTimeline } from "react-icons/ci";


const ComplianceTopBar = (props) => {
    const {
        menuitem,
        setMenuItem,
        activeComplianceId,
        complianceStandards,
        setSidebarCollapsedFN,
        sidebar_collapsed,
        openReport,
    } = props;

    ////////console.log("active comlpiance id: ", activeComplianceId);
    const getSvgProps = (path) => {
        return menuitem === path
            ? { fill: "#3b3b3b", what: path }
            : { fill: "#c3cfd1", what: path };
    };

    ////////console.log(complianceStandards);
    const activeCompliance =
        complianceStandards?.find((standard) => standard.compliance_id === activeComplianceId) || {};
    ////console.log(activeCompliance)
    const activeComplianceName = activeCompliance?.name || "N/A";
    const activeComplianceColor = activeCompliance?.color || "";
    const company_name = activeCompliance?.company_name  || "";

    return (
        <div
            className={`flex w-full h-16 bg-[#F0F0F2] transition-width duration-300 border-b border-gray-300 shadow`}
        >
            {sidebar_collapsed && (
                <div>
                    <button
                        className="p-5 pl-0 ml-5"
                        onClick={() => setSidebarCollapsedFN(!sidebar_collapsed)}
                        title="Toggle sidebar"
                    >
                        <div className="relative flex items-center justify-center w-8 h-8 hover:bg-white hover:rounded-full mt-[-2px] transition">
                            <LuPanelLeft className="w-5 h-5 text-[#3b3b3b] hover:text-black" />
                        </div>
                    </button>
                </div>
            )}
            
            <nav className="flex flex-row justify-start w-full overflow-x-auto whitespace-nowrap scrollbar-hide">
              <div className="flex items-center p-2 mx-4 text-[#464646] text-mm">
  <div
    title={activeComplianceName}
    className="flex items-center justify-center w-8 h-8 m-2 rounded-xl hover:bg-[#3b3b3b] hover:bg-opacity-20 ml-0"
    style={{ backgroundColor: activeComplianceColor }}
  >
    <span className="text-white font-bold text-[12px]">
      {activeComplianceName !== "N/A"
        ? activeComplianceName
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase())
            .slice(0, 2)
            .join("")
        : "NA"}
    </span>
  </div>

  {/* Text block */}
  <div className="flex flex-col ml-2 leading-tight">
    {/* Compliance name */}
    <span className="text-black font-medium">
      {activeComplianceName}
    </span>

    {/* Company name under compliance */}
    {company_name && (
      <span className="text-[11px] text-gray-500">
        {company_name}
      </span>
    )}
  </div>
</div>


                {[
                    { id: "dashboards", label: "Dashboard", icon: HiOutlineChartBar},
                    { id: "risk", label: "Risk" , icon: GoAlert},
                    { id: "controls", label: "Controls", icon: PiShieldCheck },
                    { id: "actions", label: "Actions", icon: CiViewTimeline },
                    { id: "incidents", label: "Incidents", icon: CiCircleAlert },
                    { id: "workflows", label: "Workflows", icon: LuWorkflow },
                    { id: "inventory", label: "Assets", icon: CiServer },
                    { id: "files", label: "Files", icon: BsFiles },
                    
                    {
                        id: "create_report",
                        label: "Reports",
                        icon: IoDocumentTextOutline
                        //action: openReport,
                    },
                ].map(({ id, label, icon: Icon, action }) => (
                    <button
                        key={id}
                        onClick={() => {
                            if (action) {
                                action();
                            } else {
                                //console.log("Menu", id)
                                setMenuItem(id);
                            }
                        }}
                        className={`flex items-center p-2 mx-4 text[#464646] hover:bg-white text-mm ${
                            menuitem === id
                                ? "border-b-2 border-[#3b3b3b] text-[#3b3b3b]"
                                : "text-gray-500"
                        }`}
                    >
                        {Icon ? (
                            <Icon 
                                className={`w-6 h-6`}
                                style={{ color: menuitem === id ? "#3b3b3b" : "#c3cfd1" }}
                            />
                        ) : (
                            <UnitsIcons {...getSvgProps(id)} className={`w-6 h-6`} />
                        )}
                        <span className={`ml-2`}>{label}</span>
                    </button>
                ))}
            </nav>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        sidebar_collapsed: state.auth.sidebar_collapsed,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setSidebarCollapsedFN: (collapsed) => dispatch(setSidebarCollapsed(collapsed)),
    };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(ComplianceTopBar);